var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_16766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7558 0.243448C19.6393 0.127879 19.4915 0.0489963 19.3306 0.0165596C19.1698 -0.0158771 19.003 -0.000444576 18.8508 0.0609478L0.517446 7.56095C0.351695 7.63353 0.213844 7.75775 0.124451 7.91507C0.0350575 8.07239 -0.00108935 8.2544 0.0214005 8.43394C0.0438904 8.61349 0.123812 8.78095 0.249248 8.91137C0.374683 9.04178 0.538913 9.12816 0.717446 9.15762L9.60078 10.3984L10.8416 19.281C10.8711 19.4595 10.9574 19.6237 11.0879 19.7492C11.2183 19.8746 11.3857 19.9545 11.5653 19.977C11.7448 19.9995 11.9268 19.9633 12.0842 19.8739C12.2415 19.7846 12.3657 19.6467 12.4383 19.481L19.9383 1.14761C20.0003 0.995679 20.016 0.828826 19.9835 0.667978C19.9511 0.507131 19.8718 0.359448 19.7558 0.243448Z",
    fill: "#7357EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_16766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcon);
export default __webpack_public_path__ + "static/media/submit-icon.0a7f5178c675ad786609693e28bbd349.svg";
export { ForwardRef as ReactComponent };